import { Command } from "./command.js";
/**
 * @see https://redis.io/commands/mset
 */
export class MSetCommand extends Command {
    constructor([kv], opts) {
        super([
            "mset",
            ...Object.entries(kv).flatMap(([key, value]) => [key, value]),
        ], opts);
    }
}
